import { useLayoutEffect, useRef } from 'react';

import { useListState } from '@react-stately/list';

import { useOption } from '@react-aria/listbox';

import { StyledOption } from './styled';

type ListState = ReturnType<typeof useListState>;
type Collection = ListState['collection'];

interface Props {
  item: NonNullable<ReturnType<Collection['getItem']>>;
  state: ListState;
}

export const Option = ({ item, state }: Props) => {
  const ref = useRef<HTMLLIElement>(null);
  const { optionProps, isSelected, isFocused, isDisabled } = useOption(
    { key: item.key },
    state,
    ref
  );

  // Focus the first item when there is no focused item.
  // so that user can hit Enter to select the first item in the list.
  useLayoutEffect(() => {
    if (
      state.selectionManager.focusedKey === null &&
      item.key === state.collection.getFirstKey()
    ) {
      state.selectionManager.setFocusedKey(item.key);
    }
  }, [
    item.key,
    state.collection,
    state.selectionManager,
    state.selectionManager.focusedKey,
  ]);

  return (
    <StyledOption
      {...optionProps}
      ref={ref}
      isSelected={isSelected}
      isFocused={isFocused}
      isDisabled={isDisabled}
    >
      {item.rendered}
    </StyledOption>
  );
};
